import React from 'react';

const Icon = ({ icon }) => {
    return <i className={`ri ri-${icon}`}></i>;
};

export default Icon;
